import React from 'react';
import { Form, FormField, Input, Multiselect, SpaceBetween } from '@amzn/awsui-components-react-v3';
import { OptionDefinition } from '@amzn/awsui-components-react-v3/polaris/internal/components/option/interfaces';
import { StepErrors } from 'src/components/auditReports/createReportPage/createReportWizard';

export interface NameAndDescriptionEditorProps {
  name: string;
  setName: any;
  description: string;
  setDescription: any;
  outputFormats: string[];
  setOutputFormats: any;
  stepErrors: StepErrors;
  validateFieldErrorsOnChange: any;
}

export const NameAndDescriptionEditor = (props: NameAndDescriptionEditorProps) => {
  const nameIsValid = (name: string) => {
    return name == undefined || (name.length > 0 && name.length <= 256 && /^[A-Za-z0-9_\- ]*$/.test(name));
  };
  const descriptionIsValid = (description: string) => {
    return description == undefined || (description.length > 0 && description.length <= 4056);
  };

  const OUTPUT_FORMAT_OPTIONS: OptionDefinition[] = [
    { label: 'Excel', value: 'EXCEL' },
    { label: 'JSON', value: 'JSON', disabled: true },
  ];

  return (
    <Form>
      <SpaceBetween size={'m'} direction={'vertical'}>
        <FormField
          label={'Report name'}
          constraintText={'Only alphabets, numbers, spaces, _ and - characters allowed.'}
          errorText={props.stepErrors?.name}
        >
          <Input
            value={props.name}
            placeholder={'My Audit Report'}
            onChange={(e) => {
              props.setName(e.detail.value);
              props.validateFieldErrorsOnChange('name', e.detail.value);
            }}
            invalid={!nameIsValid(props.name)}
          />
        </FormField>
        <FormField label={'Report description'} errorText={props.stepErrors?.description}>
          <Input
            value={props.description}
            placeholder={'A description of the report for your own reference'}
            onChange={(e) => {
              props.setDescription(e.detail.value);
              props.validateFieldErrorsOnChange('description', e.detail.value);
            }}
            invalid={!descriptionIsValid(props.description)}
          />
        </FormField>
        <FormField
          label={'Output formats'}
          description={
            'Select what format(s) you would like to receive the report in. Right now, only Excel and Json is supported.'
          }
        >
          <Multiselect
            selectedOptions={props.outputFormats.map((type) => {
              return OUTPUT_FORMAT_OPTIONS.find((option) => option.value === type);
            })}
            onChange={(e) => props.setOutputFormats(e.detail.selectedOptions.map((option) => option.value))}
            options={OUTPUT_FORMAT_OPTIONS}
          />
        </FormField>
      </SpaceBetween>
    </Form>
  );
};
